<a id="partCardHeader_a_PartDetailLink{{idSuffix}}"
  [routerLink]="isInModal ? null : ['/parts']"
  [queryParams]="isInModal ? null : {searchTerm:part.rushPartNumber,partId:part.partId, src:partType}"
  [class.cursor-pointer]="isInModal"
  (click)="onPartClick($event)">
  <h4 class="product-card-title m-0 px-3 py-2 d-flex justify-content-between">
    <span class="strong text-truncate" title="{{part.rushPartNumber}}">
      {{part.rushPartNumber}}
    </span>
    <div>
      @if (isGrowth$ | async) {
        <span id="partCardHeader_span_IsGrowthIcon{{idSuffix}}" title="Growth"><i class="fas fa-chart-line"></i>&nbsp;&nbsp;</span>
      }
      @if (isRecovery$ | async) {
        <span id="partCardHeader_span_IsRecoveryIcon{{idSuffix}}" title="Recovery"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;</span>
      }
      @if (isFavoritePart) {
        <a id="partCardHeader_a_IsFavoritePart{{idSuffix}}" role="button" href="javascript:void(0)" title="Remove from Favorites"
          (click)="removeFavoritePart(part); $event.stopPropagation()">
          <i class="fas fa-star"></i>
        </a>
      }
      @if (!isFavoritePart) {
        <a id="partCardHeader_a_IsNotFavoritePart{{idSuffix}}" role="button" href="javascript:void(0)" title="Add to Favorites"
          (click)="addToFavoriteParts(part); $event.stopPropagation()">
          <i class="far fa-star"></i>
        </a>
      }
      &nbsp;
      @if (showCopyIcon) {
        <a id="partCardHeader_a_ShowCopyIcon{{idSuffix}}" role="button" href="javascript:void(0)" title="Copy Part Number to Clipboard"
          (click)="copyToClipBoard(part.rushPartNumber); $event.stopPropagation()">
          <i class="far fa-clone"></i>
        </a>
      }
    </div>
  </h4>
</a>
